import { Menu } from 'antd'
import { AdditionalValesTableMenuItems } from './constants'
import Typography from '../../../components/Typography/Typography'
import { TMenuItemsProps } from './types'
import { useAdditionalValuesPopup } from '../Providers/AdditionalValuesPopupProvider'
import { useAdditionalValuesContext } from '../Providers/AdditionalValuesContextProvider'

export const AdditionalValuesTableMenuItems = ({
  row,
  setVisible
}: TMenuItemsProps) => {
  const { deleteAdditionalValuesPopup, addEditAdditionalValuesPopup } =
    useAdditionalValuesPopup()
  const {
    actions: { setSelectedAdditionalValue }
  } = useAdditionalValuesContext()
  const handleDelete = () => {
    setSelectedAdditionalValue(row)
    deleteAdditionalValuesPopup.actions.open()
  }
  const handleClick = (key: string) => {
    !!setVisible && setVisible(false)
    switch (key) {
      case 'edit': {
        addEditAdditionalValuesPopup.actions.open()
        setSelectedAdditionalValue(row)
        return
      }
      case 'delete':
        return handleDelete()
      default:
        return
    }
  }
  return (
    <Menu className="menu-items-wrapper actual-savings-menu" selectedKeys={[]}>
      {AdditionalValesTableMenuItems.map((i) => (
        <Menu.Item key={i.key} onClick={() => handleClick(i.key)}>
          <Typography.Body1>{i.label}</Typography.Body1>
        </Menu.Item>
      ))}
    </Menu>
  )
}
